// const BASE_URL = 'http://localhost:8080/api';
const BASE_URL = 'https://nexgen-autocare-backend-c1e05cbec87d.herokuapp.com/api';

export default BASE_URL;